import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore'
import { ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID } from './zohoCrmIntegrationDemo.js'
import {
  WEBSITE_CRM_PHASE2_THREAD_TITLE,
  WEBSITE_CRM_THOUGHT_DETAILS,
  WEBSITE_CRM_USER_PROMPT,
  buildWebsiteCrmDocArtifactPayload,
  buildWebsiteCrmFullFinalBlocks,
  buildWebsiteCrmHtmlArtifactPayload,
} from './websiteCrmDemoContent.js'
import {
  NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
} from './nexusIntegrationsDemo.js'
import { buildZohoCrmIntegrationArtifactPayload } from './zohoCrmIntegrationDemoContent.js'



export const WEBSITE_CRM_DEMO_THREAD_ID = 'thread-demo-nexus-website-crm'

export const WEBSITE_CRM_DEMO_EXCHANGE_ID = 'exchange-demo-nexus-website-crm'

export const WEBSITE_CRM_DEMO_USER_MSG_ID = 'msg-demo-nexus-website-crm-user'

export const WEBSITE_CRM_DEMO_ASSISTANT_MSG_ID = 'msg-demo-nexus-website-crm-assistant'

export const WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID = 'artifact-demo-nexus-website-html'

export const WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID = 'artifact-demo-nexus-crm-test-report'

export const WEBSITE_CRM_DEMO_CONTENT_VERSION = 9

const DEMO_NOW = 1_748_610_000_000

export function ensureWebsiteCrmDemoArtifactsRegistered() {
  registerArtifactPayload({
    artifactId: WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
    kind: 'html',
    fileName: 'NexusB2B — Procurement Site.html',
    description: 'HTML App',
    payload: buildWebsiteCrmHtmlArtifactPayload(),
  })
  registerArtifactPayload({
    artifactId: ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID,
    kind: 'doc',
    fileName: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
    description: 'Markdown',
    payload: buildZohoCrmIntegrationArtifactPayload(),
  })
  registerArtifactPayload({
    artifactId: WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID,
    kind: 'doc',
    fileName: 'NexusB2B — CRM Test Report.md',
    description: 'Markdown',
    payload: buildWebsiteCrmDocArtifactPayload(),
  })
}

/**
 * @returns {{ thread: { id: string, title: string, createdAt: number, updatedAt: number }, messages: object[] }}
 */
